import { ReactComponent as MyIcon } from './support-svgrepo-com.svg';

const Features = () => {
  return (
    // <section className={`ml-5`} id="portfolio">
    //   <div className="container mx-auto mt-8">
    //     <div className="py-4 text-white font-medium lg:columns-3 md:columns-2 sm:columns-1 bg-sky-200/[0.15] bg-clip-border justify-items-center">
    //       {projects
    //         .map((p) => (
    //           <ProjectCard {...p} />
    //         ))}
    //     </div>
    //   </div>
    // </section>
    <div>
        <div className='justify-center text-center text-2xl md:text-3xl xl:text-4xl font-bold tracking-tight mb-6'>
            Features
        </div>
        <div class="justify-center grid grid-cols-3 place-items-center">
            <div>
              <img src="security2.jpg" width="450px"/>
            </div>
            <div>
              <img src="sm3.jpeg" width="450px"/>
            </div>
            <div>
              <img src="edit.jpg" width="450px"/>
            </div>
            <div className='text-center font-semibold text-[20px]'>Secure Payment</div>
            <div className='text-center font-semibold text-[20px]'>Social Sharing</div>
            <div className='text-center font-semibold text-[20px]'>Edit Campaign</div>
        </div>
    </div>
  );
};

export default Features;
